export const ConsumerSearchType = {
  VENUE: 'VENUE',
  EVENT: 'EVENT',
  CURATED_LIST: 'CURATED_LIST',
} as const

export type ConsumerSearchTypeValue =
  (typeof ConsumerSearchType)[keyof typeof ConsumerSearchType]

export const SEARCH_CONSUMER_TYPE_VALUES = Object.values(ConsumerSearchType)

/** Labels for GET /search-consumer-type (legacy Algolia search-type.js parity). */
export const SEARCH_CONSUMER_TYPE_OPTIONS: ReadonlyArray<{
  name: string
  value: ConsumerSearchTypeValue
}> = [
  { name: 'Venues', value: ConsumerSearchType.VENUE },
  { name: 'Events', value: ConsumerSearchType.EVENT },
  { name: 'Lists', value: ConsumerSearchType.CURATED_LIST },
]

export const SEARCH_CONSUMER_QUERY_MAX_LEN = 512

export const SearchConsumerErrorMessage = {
  INVALID_QUERY: 'query must be a string between 0 and 512 characters',
} as const
